import { render, staticRenderFns } from "./TlmChip.vue?vue&type=template&id=15e4e2f0"
import script from "./TlmChip.vue?vue&type=script&lang=js"
export * from "./TlmChip.vue?vue&type=script&lang=js"
import style0 from "./TlmChip.vue?vue&type=style&index=0&id=15e4e2f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports